/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ResetPasswordResponse model module.
 * @module model/ResetPasswordResponse
 * @version v1
 */
export class ResetPasswordResponse {
  /**
   * Constructs a new <code>ResetPasswordResponse</code>.
   * @alias module:model/ResetPasswordResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ResetPasswordResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ResetPasswordResponse} obj Optional instance to populate.
   * @return {module:model/ResetPasswordResponse} The populated <code>ResetPasswordResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ResetPasswordResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('account'))
        obj.account = ApiClient.convertToType(data['account'], Object);
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
ResetPasswordResponse.prototype.status = undefined;

/**
 * @member {Object} account
 */
ResetPasswordResponse.prototype.account = undefined;

/**
 * @member {String} message
 */
ResetPasswordResponse.prototype.message = undefined;

